export const queryNames = {
  taskId: 'taskId',
  taskItemId: 'taskItemId',
  planId: 'planId',
  whichMain: 'whichMain',
  labelId: 'labelId',
  replyToTaskItemId: 'replyToTaskItemId',
}
